export class StepControl {
  constructor(array, func, options = {}) {
    this.array = array ?? [];
    this.func = func;
    this.currentStep = -1;
    this.end = false;
    this.returnValues = this.array.slice().fill(null);
    this.promise = new Promise((resolve, reject) => {
      this.resolveComplete = resolve;
      this.rejectEnd = reject;
    });
    this.autoEndOnNoPrevious = options.autoEndOnNoPrevious ?? false;
    this.autoEndMethod = options.autoEndMethod ?? this.cancel;
    this.error = null;
  }

  callFunc = (stepIndex) => {
    try {
      this.func(this.array[stepIndex], [this.next, this.previous, this.cancel, this.forceEnd]);
    } catch (error) {
      this.cancel(error);
    }
  };

  next = (value) => {
    if (this.currentStep >= 0) {
      this.returnValues[this.currentStep] = value;
    }
    const nextStep = ++this.currentStep;
    if (nextStep >= this.array.length) {
      this.complete();
    } else {
      this.callFunc(nextStep);
    }
  };

  previous = () => {
    if (this.currentStep !== 0) {
      const prevStep = --this.currentStep;
      this.returnValues[prevStep] = null;
      this.callFunc(prevStep);
    } else if (this.autoEndOnNoPrevious) {
      this.autoEndMethod();
    }
  };

  complete = () => {
    this.end = true;
    this.resolveComplete(this.returnValues);
  };

  cancel = (error) => {
    this.end = true;
    this.error = error;
    this.rejectEnd(this.error);
  };

  forceEnd = (value) => {
    this.returnValues[this.currentStep] = value;
    this.complete();
  };

  start = () => {
    this.next();
    return this.promise;
  };
}
